export default "__VITE_ASSET__mW7fX1QH__"